import { render, staticRenderFns } from "./LocationEmptyState.vue?vue&type=template&id=2e8c40f8&scoped=true&"
import script from "./LocationEmptyState.vue?vue&type=script&lang=ts&"
export * from "./LocationEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./LocationEmptyState.vue?vue&type=style&index=0&id=2e8c40f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c40f8",
  null
  
)

export default component.exports